import { render, staticRenderFns } from "./VESQuestionnairePanels.vue?vue&type=template&id=19abb458&"
import script from "./VESQuestionnairePanels.vue?vue&type=script&lang=js&"
export * from "./VESQuestionnairePanels.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/questionnaires/components/ves-questionnaire-panels.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports